import React from 'react';
import { TemplateDefault } from 'src/templates/TemplateDefault';

// import s from './About.module.scss';

export const About: React.FC = () => {
  return <TemplateDefault>About</TemplateDefault>;
};
